import React from 'react';
import { Subscribe } from 'unstated';
import { RouteComponentProps } from 'react-router-dom';
import FeatureContainer from '../../state/containers/FeatureContainer';
import LatestMessageContainer from '../../state/containers/LatestMessageContainer';
import UpdateLatestMessageContentForm from './components/UpdateLatestMessageContentForm';
import ApplicationContainer from '../../state/containers/ApplicationContainer';
import TitleStateContainer from '../../state/containers/TitleStateContainer';
import RepromptContainer from '../../state/containers/RepromptContainer';
import FollowUpContainer from '../../state/containers/FollowUpContainer';
import MediaResponseStateContainer from '../../state/containers/MediaResponseContainer';
import IResult from '../../models/result/IResult';
import LatestMessageModel from '../../models/features/api/LatestMessages/LatestMessageModel';
import GenericEditContentItemPage from '../formScenes/GenericEditContentItemPage';
import { LatestMessagesFeatureTypeId } from '../../constants/featureTypeIds';
import queryString from 'query-string';
import ApplicationEnvironmentsContainer from '../../state/containers/ApplicationEnvironmentsContainer';
import ApplicationBackupVersionsContainer from '../../state/containers/ApplicationBackupVersionsContainer';

interface ApplicationRouteProps {
    applicationFeatureId: string
    latestMessageId: string
}
interface EditLatestMessageProps extends RouteComponentProps<ApplicationRouteProps> { }

class EditLatestMessage extends React.Component<EditLatestMessageProps> {
    render() {
        return (
            <Subscribe key={this.props.match.params.latestMessageId + this.props.match.params.applicationFeatureId} to={[
                LatestMessageContainer,
                ApplicationContainer,
                TitleStateContainer,
                RepromptContainer,
                FollowUpContainer,
                MediaResponseStateContainer,
                FeatureContainer,
                ApplicationEnvironmentsContainer,
                ApplicationBackupVersionsContainer]}>
                {(latestMessageContainer: LatestMessageContainer,
                    appContainer: ApplicationContainer,
                    titleContainer: TitleStateContainer,
                    repromptContainer: RepromptContainer,
                    followUpContainer: FollowUpContainer,
                    responseContainer: MediaResponseStateContainer,
                    featureContainer: FeatureContainer,
                    environmentsContainer: ApplicationEnvironmentsContainer,
                    backupsContainer: ApplicationBackupVersionsContainer) => {
                    return (
                        <GenericEditContentItemPage stateContainer={latestMessageContainer}
                            environmentsContainer={environmentsContainer}
                            backupsContainer={backupsContainer}
                            titleContainer={titleContainer}
                            applicationContainer={appContainer}
                            defaultTitle="Edit Latest Message"
                            contentItemId={this.props.match.params.latestMessageId}
                            history={this.props.history}
                            location={this.props.location}
                            match={this.props.match}
                            staticContext={this.props.staticContext}
                            featureContainer={featureContainer}
                            featureTypeId={LatestMessagesFeatureTypeId}
                            formRender={(contentItem: LatestMessageModel,
                                application,
                                isTemplateOwned,
                                assistantApplication,
                                onShowPublishModal,
                                onSubmit: (model: LatestMessageModel, onSuccess) => Promise<IResult<LatestMessageModel>>,
                                toggleSync: (id, shouldNotSync) => Promise<IResult<LatestMessageModel>>,
                                onAccessTypeChange) => (
                                <UpdateLatestMessageContentForm
                                    location={this.props.location}
                                    applicationFeatureId={this.props.match.params.applicationFeatureId}
                                    application={application}
                                    latestMessage={contentItem}
                                    stateContainer={latestMessageContainer}
                                    repromptContainer={repromptContainer}
                                    followUpContainer={followUpContainer}
                                    appContainer={appContainer}
                                    responseStateContainer={responseContainer}
                                    featureContainer={featureContainer}
                                    assistantApplication={assistantApplication}
                                    onShowPublishModal={onShowPublishModal}
                                    onAccessTypeChange={onAccessTypeChange}
                                    onSubmit={onSubmit}
                                    onToggleSync={toggleSync}
                                    previousContentId={queryString?.parse(this.props.location.search)?.previousContentId as string}
                                    history={this.props.history}
                                    isSaving={latestMessageContainer.state.isSaving}
                                    isTemplateOwned={isTemplateOwned} />
                            )} />
                    );
                }}
            </Subscribe>
        );
    }
}

export default EditLatestMessage;